import type { CcxtMarket } from '@/services/types'
import { useCoreStore } from '@/stores/coreStore'
import { calcDecimals } from '@/utils'
import { computed, ref, type Ref } from 'vue'

export const useCexDexMarketData = (cex: Ref<string>, symbol: Ref<string>, chain: Ref<string>) => {
  const contract = computed(() => validPools.value[0]?.contract ?? null)
  const market = ref<CcxtMarket>()
  const ctrActionId = computed(() => `contract/${cex.value}/${symbol.value}`)
  const coreStore = useCoreStore()
  const validPools = ref()
  const marketActionId = computed(() => `market/${contract.value}/${chain.value}`)

  const commonRounding = computed(() => calcDecimals(market?.value?.precision.price ?? 0.00000001))
  const asset = computed(() => symbol.value.split('/')[0] as string)

  const fetchMarket = async () => {
    market.value = await coreStore.fetchMarket(
      marketActionId.value,
      cex.value as string,
      symbol.value.replace('/', '_'),
    )
  }

  const fetchContractData = async () => {
    const ctrData = await coreStore.fetchContracts(
      ctrActionId.value,
      cex.value,
      asset.value,
      'swap',
    )
    if (!ctrData) {
      return
    }
    validPools.value = ctrData.filter(
      (x) => x.chain.name.toLowerCase() == chain.value.toLowerCase(),
    )
  }

  const fetchPoolSwap = async () => {
    if (!contract.value) {
      await fetchContractData()
    }
    if (!contract.value) {
      throw Error('no_contract')
    }
    return (await coreStore.fetchPoolDeveloper('dev', contract.value, chain.value)) ?? 'DEX'
  }

  return {
    fetchContractData,
    fetchPoolSwap,
    fetchMarket,
    validPools,
    market,
    contract,
    commonRounding,
  }
}
